<template lang="pug">
  .detailsBox
    .details(v-if="flag==1")
      h3 签约兰州市税务局——速云软件&钉钉数字一体化解决方案，赋能政务办公
      span 编辑:网站客服部
      span 更新时间：2021-03-01
      p 随着从严治党的深入开展，党政机关单位的工作纪律也日益加强，各级纪检部门也加大了对党政机关的监督检查力度，上下班考勤也成为了党政机关人事部门的日常工作。这项看似简单的工作，在实践过程中往往还存在着一些问题。
      p 例如：职工休假、病假、事假以及因公出勤管理制度存在着不足，尤其是当纪检部门来检查的时候，快速、全面的提供单位全体干部职工的出勤情况和实时去向，成为了困扰人事部门工作人员的难题。
      p 近期，国家税务总局兰州市税务局在关于加强组织内部人事管理问题上，向我们提出了需求。
      p 速云软件&钉钉数字一体化解决方案赋能政务办公
      p 针对政务工作覆盖范围广、条块复杂、安全稳定性能要求高等特点，从通讯录、即时通讯、考勤管理、文档管理、工作门户、开放平台、安全保障和运维服务等方面做了专业研究和专属定制。基于政务办公的特殊性，采用了高强度算法实施加密保护，确保数据安全。
      p 解决后的人事管理方面，管理员可随时随地实时了解组织人效、入职、离职、学历、年龄等多维度信息对比。轻松实现人事管理，自动生成代办事项，让工作安排条理有序。不仅如此，管理员可根据本单位的考勤制度，自定义考勤规则，无论是临时值班或是外勤问题，都可轻松解决。
      img(src="https://file.s5yun.com/resources/appico/16161423150407892_dingdingm2.png" alt="")
      p 同时，特别搭载了钉钉M2人脸识别考勤机，结合软件系统，加强对人事考勤的管理。职工在进入时不需指纹打卡、手机打卡，只需路过它面前看它一眼即可完成打卡，这是基于遵循弱感知或者无感知的设计原则。并且，3米范围可在0.6秒钟之内对多人进行人脸识别，并可适应各种光线环境，甚至还能对职工的微笑程度进行打分。众所周知，安全对于政务工作的重要性，钉钉M2采用的是活体人脸识别技术，只有面对真人才有效，照片无效，而且即使设备在离线状态，依然能够正常识别。职工考勤数据实时计入考勤统计，实现方便快捷的无缝整合。
      p 一直以来，速云软件以让人人享受数智生活为使命，积极行动，把先进的移动办公理念传播给广大用户，帮助更多的政府部门、企业、教育机构等单位提效率降成本优管理，助其实现数字化转型。
      p 服务电话：400-0931866
    .details(v-if="flag==2")
      h3 2021“陇政钉”新功能培训会
      span 编辑:网站客服部
      span 更新时间：2021-02-03
      p 新年新气象，为更好的为甘肃政务服务，“陇政钉”作为甘肃省统一的政务移动办公平台，也进行了功能更新。2020年2月3日，“陇政钉”移动办公系统新功能培训会在兰州速云软件有限公司会议室召开。本次培训会通过线上与线下结合的方式，云会场访问数达4000人次，13个群联播达到了1330人次。下面我们就一起来看看“陇政钉”本次都更新了哪些新功能：
      p 1.督察督办功能：政府工作报告、重点项目、重点工程、领导交办等任务的清晰下达与督办，加强督查工作的制度化、标准化、规范化。完善工作机制，建立健全的统一领导、分工协作、上下联动、齐抓共管的政府督查工作机制。对重点工作的目标、结果、责任、时效清晰下达与督办，减少督查室重复操作。
      p 2.用印申请功能：用印申请功能从实际出发，进一步压缩政府部门用印审批时间，完成管理、申请、审批、使用等线上一站式操作。
      p 3.指尖上的公车管理：公务用车流程规范化、标准化，申请—审批—派车—出车—还车数字系统自动流转归档，省力省心。
      p 4.资产管理功能：通过资产档案、资产入库、资产领用、资产维修、报废等功能实现资产电子化管理，所有资产状态一键查询，实时输出报表，资产盘点方便快捷，资产状态实时更新，随时管控，方便资产管理员对资产的流向进行跟踪和监管，实现资产的全员化应用和流程化管理。
      p 5.智慧投票功能：通过线上视频投票，进行数据收集，也可将投票内容进行多渠道分享，最关键的是能防止作弊，让投票打分变得安全、透明、简单、高效。
      img(src="https://file.s5yun.com/resources/appico/16152813755941755_new8.png" alt="")
      p 6.个性化智慧食堂功能：链接多元需求 助推机关智慧食堂建设。
      img(src="https://file.s5yun.com/resources/appico/16152813798679223_new9.png" alt="")
      p 7.安全沟通功能：在这个以互联网为主的信息时代，政务信息安全尤其重要。“陇政钉”移动办公系统工作群内聊天界面、文档预览界面均包括账户水印，用于泄露后追查溯源。在聊天界面中安卓端屏蔽了截屏、录屏功能，IOS端屏蔽了录屏功能，从源头上阻断截屏泄露的风险。群内消息、文件无法被转发，也大大减少了工作人员误操作的隐患。
      p 自上线以来“陇政钉”，平台已覆盖省、市、县、乡、村五级党政机关，具备“横向到边、纵向到底”的政务沟通能力。在新冠疫情防控期间，全省通过“陇政钉”累计召开视频及电话会议74万小时，钉消息400多万条，钉电话300多万条；截至目前，“陇政钉”总注册99.4万人，激活92.2万人，激活率92.7%。随着数字化政府的深入推进，“陇政钉”平台将继续借鉴先进经验，以安全为核心，以数据为支撑，为助力办公无纸化改革提供有力支撑。
    .details(v-if="flag==3")
      h3 速云软件成功签约第五届兰州科技成果博览会科技合作与成果交易项目
      span 编辑:网站客服部
      span 更新时间：2020-09-20
      p 20日，由甘肃省科学技术厅和兰州市人民政府主办的第五届兰州科技成果博览会科技合作与成果交易项目签约暨颁奖仪式在兰州举行。本届科博会签约总额达65.73亿元，其中，科技产业投资项目46.71亿元，占签约金额的71.06%;科技成果转移转化与技术交易签约金额19.02亿元，比上届科博会增长11.23%。
      p 本届科博会围绕科技合作项目、科技成果转移转化与技术交易项目、科技产业投资项目等三类项目进行了签约。
      img(src="https://file.s5yun.com/resources/appico/16152813713034423_new7.png" alt="")
      p 活动共举行签约、授牌、颁奖、发布技术创新需求和发布签约公告等五项内容。作为此次活动的重头戏，本届兰州科博会围绕科技合作项目、科技成果转移转化与技术交易项目、科技产业投资项目等先后组织了签约。其中，在科技合作项目签约环节，分别签订了2020年兰州市十大科技项目和2020年兰州市十大科技创新项目，共支持资金1700万元。在科技成果转移转化与技术交易项目签约环节，共签订项目258项，签约金额达19.02亿元。在科技产业投资项目签约环节，共组织签订项目25个，投资金额达46.71亿元。据悉，科技产业投资项目是今年首次列入兰州科博会签约内容，也是本届兰州科博会的亮点之一。
      p 速云软件凭借速云平台这一创新产品，在本次科技成果博览会科技合作与成果交易项目上成功签约，使得速云软件在今后的产品研发过程中有了更大的动力与资金，为我国的信息化技术服务做出更大的贡献！
      p 本届科博会在线上展览展示了科技创新成就、兰州白银国家自主创新示范区、榆中生态创新城、十大生态产业、智慧城市、国际与国内科技合作、科技嘉年华、科技助力脱贫攻坚成就等8个方面的优秀科技成果，共评出优秀展品奖35个，其中金奖5个、银奖10个、铜奖20个。
      p 现场，还对第五届中国创新挑战赛(甘肃·兰州)企业技术创新需求暨《兰州市重点人才项目重大技术攻关专项“揭榜挂帅”活动方案》进行了发布。本次挑战赛以解决技术需求为目标，经公开征集，遴选了124项技术创新需求，面向全国公告，寻求挑战者，通过“揭榜比拼”的方式，择优确定解决方案。
    .details(v-if="flag==4")
      h3 防疫有我、爱卫同行，创文有我、爱卫同在
      span 编辑:网站客服部
      span 更新时间：2020-07-17
      p 打好物业行业创建全国文明城市决胜战，鼓足干劲迎接我市创建全国文明城市的“大考”。7月17日下午，市住建局组织召开物业行业创建全国文明城市攻坚冲刺推进会暨物业行业爱国卫生运动教育培训会。
      img(src="../../assets/images/news/new5.jpg" alt="")
      p 会议以视频会议的形式召开，共设9个会场，主会场设在市住建局，分会场设在各区县住建局，市住建局党组成员、副局长臧海峰，市爱卫办主任王鹏洋，市文明办副主任王玉涛，各区县住建局、高新区建设和房产管理局相关负责同志，市物业行业协会，以及全市各物业服务企业共900余人参加会议。会议总结通报了我市今年以来物业行业创建全国文明城市工作，分析了存在的问题和不足，明确了下一阶段工作目标和任务。此次视频会议是由兰州速云软件科技有限公司（以下简称兰州速云）的速云平台做技术支撑，结合罗技视频会议系统，助力本次会议的顺利召开。兰州速云作为兰州的实力企业，其旗下的速云平台、陇政钉等产品，早已被应用于各大政企、学校，并收获了广泛的好评！
      p 会议对全市住建部门、物业行业管理部门、各物业服务企业众志成城、全力以赴、攻坚克难抗击疫情工作予以表扬，对疫情防控期不计个人得失、不畏困难险阻，奋战在抗击疫情一线各类人员表示感谢。
      img(src="../../assets/images/news/new6.jpg" alt="")
      p 会议要求物业行业继续发扬上半年疫情防控时期的工作作风，在科学精准做好常态化疫情防控工作的同时，认清形势、找准差距、补齐短板，按照市委市政府工作部署，严格落实行业监管职责和属地化管理责任，强化日常监管，靠实工作责任，对标对表狠抓问题整改。
      p 会议强调物业行业要增强创建工作的紧迫感，努力担负创建工作重任，提高创建工作成效，健全创建工作长效机制，集中利用一个月时间，以背水一战的决心和志在必胜的信心打好我市物业行业创建工作决胜战，全力完成好市委市政府交办的创建工作任务。
      p 市文明办副主任王玉涛到会进行了指导，市爱卫办主任王鹏洋就物业行业如何开展爱国卫生运动进行了专题培训。市物业行业协会代表全市物业服务企业做了表态发言。
    .details(v-if="flag==5")
      h3 携手“陇政钉”甘肃省司法厅召开2020年度第一期监狱戒毒人民警察晋升一级、二级监督警衔培训班开班仪式
      span 编辑:网站客服部
      span 更新时间：2020-06-07
      p 7月6日，甘肃省甘肃省司法厅利用钉钉（陇政钉）+罗技视频会议设备召开2020年度第一期监狱戒毒人民警察晋升一级、二级警督警衔培训班，开班仪式在省司法行政干警培训中心举行。
      img(src="../../assets/images/news/new1.jpg" alt="")
      p 省司法厅党委委员、政治部主任李嘉树同志出席并讲话，省司法厅人事处处长宋宗萍同志主持会议，省司法行政干警培训中心主要领导及全省各监狱学员通过陇政钉平台参加了此次开班仪式。
      img(src="../../assets/images/news/new2.jpg" alt="")
      p “陇政钉”是一款基于速云平台的明星产品，严谨的应用权限控制，不仅有效的提高平台的安全性，减少误操作、数据泄露等风险的发生，且有效提升了日常政务工作的效率，职责清晰，自定义LOGO，实现品牌建设。
      p 无论是“陇政钉”还是罗技视频会议设备，均依托于速云平台的强大优势。速云平台，是通过钉钉严格审核，钉钉官方认可上架的应用平台，使用PaaS+SaaS结构，底层结构和钉钉完全打通，可以轻松实现和钉钉各个板块的融合互通。它最大的优势是，是一款面向管理者和业务人员低代码应用搭建平台，能够提供代码扩展应用集成能力，帮助企业轻松构建专属的业务应用，具有强大的平台基础，可快速搭建应用，完善的支撑架构以及可视化的功能设计。
    .details(v-if="flag==6")
      h3 兰州速云软件科技有限公司成立于2017年
      span 编辑:网站客服部
      span 更新时间：2020-04-16
      p 我们是一家有着近二十年IT技术服务的互联网公司，我们为各行各业提供专业的IT技术服务，经过17年的发展壮大，IT行业的飞速发展现已进入一个跨时代的数字化领域；于2017年12月19日我们成立了兰州速云软件科技有限公司，他是一家专为数字化信息建设提供服务的公司。
      img(src="../../assets/img/goods2.jpg" alt="")
      p 兰州速云软件科技有限公司致力于软件开发、数字信息化建设、为行业品牌企业提供智慧管理、数字经济体建立，全方位保障企业数智化基础设施服务，使目标客户更加信赖企业的产品及服务，从而提高企业的品牌价值。目前公司已拥有自主研发的品牌“速云”，其旗下的“速云平台”、“速云食堂”等明星产品已通过认证成功上架钉钉应用市场，广泛应用于各类企业的办公中。
      p 值得一提的是，我们的“陇政钉”产品，它能够有效的提高平台的安全性，减少误操作、数据泄露等风险的发生，有效提升了日常政务工作的效率，职责清晰，自定义LOGO，实现品牌建设，从而获得了用户的一致好评，为甘肃省政务办公的数字化建设带来了极大的推动力。
      p 一直以来，公司以“让人人享受数智生活”为使命，打造了一支集合了八十多名有着多年行业经验的技术服务团队，其中研发工程师37名，部署专家25名，运维工程师21名，完善的公司组织架构和强硬的员工技能素质，只为能够为客户提供更加优质的技术支持与服务。
      p 公司秉承着“致力于推进和改变互联数智时代下人们的工作和生活，打造一支敢想敢拼的队伍”为愿景；坚持着“客户第一、团队合作、拥抱变化、诚信、激情、敬业”的价值观；坚信着“客户第一、团队合作、拥抱变化、诚信、激情、敬业”的信念，不断创新，团结协作，为中国的数智化事业贡献出一份强大的力量！
    .btns(v-if="flag==1")
      a(href="javascript:;") 上一篇：暂无其他新闻
      a(href="javascript:;" @click="next(2)") 下一篇：2021“陇政钉”新功能培训会
    .btns(v-if="flag==2")
      a(href="javascript:;" @click="next(1)") 上一篇：签约兰州市税务局——速云软件&钉钉数字一体化解决方案，赋能政务办公
      a(href="javascript:;" @click="next(3)") 下一篇：速云软件成功签约第五届兰州科技成果博览会科技合作与成果交易项目
    .btns(v-if="flag==3")
      a(href="javascript:;" @click="next(2)") 上一篇：2021“陇政钉”新功能培训会
      a(href="javascript:;" @click="next(4)") 下一篇：防疫有我、爱卫同行，创文有我、爱卫同在
    .btns(v-if="flag==4")
      a(href="javascript:;" @click="next(3)") 上一篇：速云软件成功签约第五届兰州科技成果博览会科技合作与成果交易项目
      a(href="javascript:;" @click="next(5)") 下一篇：携手“陇政钉”甘肃省司法厅召开2020年度第一期监狱戒毒人民警察晋升一级、二级监督警衔培训班开班仪式
    .btns(v-if="flag==5")
      a(href="javascript:;" @click="next(4)") 上一篇：防疫有我、爱卫同行，创文有我、爱卫同在
      a(href="javascript:;" @click="next(6)") 下一篇：兰州速云软件科技有限公司成立于2017年
    .btns(v-if="flag==6")
      a(href="javascript:;" @click="next(5)") 上一篇：携手“陇政钉”甘肃省司法厅召开2020年度第一期监狱戒毒人民警察晋升一级、二级监督警衔培训班开班仪式
      a(href="javascript:;") 下一篇：暂无其他新闻
</template>

<script>
export default {
  data () {
    return {
      flag: 0
    }
  },
  created () {
    this.flag = Number(this.$route.query.id)
  },
  methods: {
    up () {
      window.scroll(0, 476)
      this.flag = this.flag + 1
    },
    next (index) {
      window.scroll(0, 476)
      this.flag = index
    }
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .detailsBox{
    width: 100%;
    border-top: 1px solid #E6E6E6;
    .details{
      width: 70%;
      margin: 0 auto;
      text-align: center;
      h3{
        font-size: 24px;
        color: #007BF9;
        font-weight: 400;
        margin: 59px 0 32px;
      }
      span{
        color: #999;
        padding-right: 16px;
      }
      p{
        font-size: 14px;
        color: #333;
        text-align: justify;
        margin: 20px 0;
        line-height: 30px;
        text-indent: 2em;
      }
      img{
        width: 80%;
        margin: 0 auto;
      }
    }
    .btns{
      width: 70%;
      margin: 0 auto;
      height: 56px;
      padding-bottom: 60px;
      a{
        width: 420px;
        padding: 0 20px;
        height: 54px;
        border: 1px solid #E6E6E6;
        line-height: 54px;
        text-align: center;
        font-size: 14px;
        color: #666;
        border-radius: 28px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      a:nth-child(1) {
        float: left;
      }
      a:nth-child(2) {
        float: right;
      }
      a:hover{
        color: #007BF9;
        border: 1px solid #007BF9;
      }
    }
  }
</style>
